// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import _ from 'lodash';

// Main library (legacy build)
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf.mjs';

// Worker (legacy build)
//Note: flagged as unused but actually required
import pdfWorker from 'pdfjs-dist/legacy/build/pdf.worker.mjs';

// expose PDFJS global variable for legacy code
window.PDFJS = pdfjsLib;

// Specify webpack public path to the worker bundle.
if (pdfjsLib && pdfjsLib.GlobalWorkerOptions) {
  pdfjsLib.GlobalWorkerOptions.workerSrc = '/dist/pdf.worker.bundle.js';
}

// Setting worker path to worker bundle.
// https://github.com/mozilla/pdf.js/blob/master/examples/webpack/main.js#L11
// https://github.com/mozilla/pdf.js/blob/master/examples/webpack/webpack.config.js#L8

//require('pdfjs-dist/build/pdf');
//require('pdfjs-dist/web/pdf_viewer'); // Only if you need `PDFJS.PDFViewer`

//PDFJS.workerSrc = 'pdf.worker.bundle.js';

// -- views
import SvgIcon from '../SvgIcon';

export default class PdfView extends Component {

  // instance fields for cleanup
  _isMounted = false;
  _loadingTask = null;
  _renderTask = null;
  _fileReader = null;

  static propTypes = {
    file: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),

    content: PropTypes.string,

    page: PropTypes.number,

    httpHeaders: PropTypes.object,

    scale: PropTypes.number,
    loading: PropTypes.object,

    onClick: PropTypes.func.isRequired,

    onDocumentComplete: PropTypes.func.isRequired,

    onPageCompleted: PropTypes.func.isRequired
  };

  static defaultProps = {
    page: 1,

    scale: 1.0,

    loading: null,

    httpHeaders: null
  };

  state = {
    pageInfo: null,

    pdf: null
  };

  componentDidMount() {
    this._isMounted = true;
    this.loadPDFDocument(this.props);
    this.renderPdf();
  }

  componentWillReceiveProps(newProps) {
    if ((newProps.file && newProps.file !== this.props.file) || (newProps.content && newProps.content !== this.props.content)) {
      this.loadPDFDocument(newProps);
    }
    if (!!this.state.pdf && !!newProps.page && newProps.page !== this.props.page) {
      this.setState({
        pageInfo: null
      });
      this.state.pdf.getPage(newProps.page).then(this.onPageCompleted).catch(err => {
        // ignore if unmounted or error
        if (this._isMounted) console.error('getPage error', err);
      });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;

    // abort FileReader
    if (this._fileReader) {
      try {
        this._fileReader.onload = null;
        if (this._fileReader.abort) this._fileReader.abort();
      } catch (e) { /* ignore */ }
      this._fileReader = null;
    }

    // cancel render task
    if (this._renderTask) {
      try {
        if (this._renderTask.cancel) this._renderTask.cancel();
      } catch (e) { /* ignore */ }
      this._renderTask = null;
    }

    // destroy loadingTask
    if (this._loadingTask) {
      try {
        if (this._loadingTask.destroy) {
          this._loadingTask.destroy();
        } else if (this._loadingTask.cancel) {
          this._loadingTask.cancel();
        }
      } catch (e) { /* ignore */ }
      this._loadingTask = null;
    }
  }

  // -- pdf loading

  onDocumentComplete = (pdf) => {
    if (!this._isMounted) return;

    this.setState({
      pdf
    });

    // notify parent with number of pages
    try {
      this.props.onDocumentComplete(pdf.numPages);
    } catch (e) { /* ignore */ }

    pdf.getPage(this.props.page).then(this.onPageCompleted).catch(err => {
      if (this._isMounted) console.error('getPage error', err);
    });
  };

  onPageCompleted = (pageInfo) => {
    if (!this._isMounted) return;

    this.setState({
      pageInfo
    });

    this.renderPdf();

    try {
      this.props.onPageCompleted(pageInfo.pageNumber);
    } catch (e) { /* ignore */ }
  };

  loadByteArray(byteArray) {
    const loadingTask = pdfjsLib.getDocument({ data: byteArray });
    this._loadingTask = loadingTask;
    loadingTask.promise.then((pdf) => {
      // ensure still mounted before proceeding
      if (this._isMounted) this.onDocumentComplete(pdf);
    }).catch((err) => {
      if (this._isMounted) console.error('PDF load error', err);
    }).finally(() => {
      // clear reference if already handled
      if (!this._isMounted) this._loadingTask = null;
    });
  }

  loadPDFDocument(props) {
    // clear previous pageInfo to force reload UI
    this.setState({ pageInfo: null });

    if (!!props.file) {

      if (_.isString(props.file)) {
        const docInitParams = _.isNull(this.props.httpHeaders) ? { url: props.file } : { url: props.file, httpHeaders: this.props.httpHeaders };
        const loadingTask = pdfjsLib.getDocument(docInitParams);
        this._loadingTask = loadingTask;
        return loadingTask.promise.then((pdf) => {
          if (this._isMounted) return this.onDocumentComplete(pdf);
        }).catch((err) => {
          if (this._isMounted) console.error('PDF load error', err);
        });
      }

      // Is a File object
      const reader = new FileReader();
      this._fileReader = reader;
      reader.onload = () => {
        if (!this._isMounted) return;
        const content = new Uint8Array(reader.result);
        this.loadByteArray(content);
      };
      reader.readAsArrayBuffer(props.file);
    } else if (!!props.content) {
      const bytes = window.atob(props.content);
      const byteLength = bytes.length;
      const byteArray = new Uint8Array(new ArrayBuffer(byteLength));
      for (let index = 0; index < byteLength; index++) {
        byteArray[index] = bytes.charCodeAt(index);
      }
      this.loadByteArray(byteArray);
    } else {
      console.error('pdfViewer works with a file(URL) or (base64)content. At least one needs to be provided!');
    }
  }

  renderCanvas() {
    return (
      <canvas
        className="pdf_canvas"
        ref="pdfCanvas"
        onClick={this.props.onClick}
      />
    );
  }

  renderPdf() {
    const pageInfo = this.state.pageInfo;

    if (!_.isNull(pageInfo)) {

      const canvas = ReactDOM.findDOMNode(this.refs.pdfCanvas);
      if (!canvas) {
        return;
      }
      const context = canvas.getContext('2d');
      const scale = this.props.scale;
      const viewport = pageInfo.getViewport({scale: scale });

      canvas.height = viewport.height;
      canvas.width = viewport.width;

      const renderContext = {
        canvasContext: context,
        viewport
      };

      // render returns RenderTask; we wait .promise if necessary
      const renderTask = pageInfo.render(renderContext);
      this._renderTask = renderTask;

      // cleanup once rendering is done/failed
      renderTask.promise.then(() => {
        this._renderTask = null;
      }).catch(err => {
        this._renderTask = null;
        if (this._isMounted) console.error('PDF render error', err);
      });
    }
  }

  renderLoading() {
    if (_.isNull(this.props.loading)) {
      return (
        <div className="pdf_canvas_loading">
          <SvgIcon
            icon={SvgIcon.LOADING_BAR}
          />
        </div>
      );
    }
    return (this.props.loading);
  }

  render() {
    if (!_.isNull(this.state.pageInfo)) {
      return this.renderCanvas();
    }

    return this.renderLoading();
  }

}
